export const getClassesForItem = (totalCount, count, isMobile) => {
	const isTotalCountEven = totalCount % 2 === 0;
	const isTotalCountBy4 = totalCount % 4 === 0;

	// No border bottom for items above link when link is on its own row
	let oneForLink = 0;
	if (isTotalCountBy4) {
		oneForLink = 1;
	} else if (totalCount % 5 === 0) {
		oneForLink = -1;
	}
	const borderBottom =
		totalCount - count >= 3 + oneForLink
			? 'border-bottom'
			: 'border-bottom-0';
	// To determine the Items appears at end/2nd-row to remove border-bottom.
	let lastItem = '';
	if (
		(isTotalCountEven && totalCount - count < 2) ||
		(!isTotalCountEven && totalCount - count === 0)
	) {
		lastItem = 'lastItem';
	}
	if (!isMobile) {
		let grids = 3;
		if (!(isTotalCountBy4 || (totalCount + 1) % 4 === 0)) {
			grids = 4;
			return `col-md-${grids} grid-4-layout ${lastItem} ${borderBottom}`;
		}

		return `col-md-${grids} grid-3-layout ${lastItem} ${borderBottom}`;
	} else {
		return `col-xs-6 ${lastItem} ${borderBottom}`;
	}
};
